import styled from 'styled-components';
import Text from '@dbh/text';

const Label=/*#__PURE__*/styled(Text).attrs({tag:"label"}).withConfig({componentId:"sc-10af9ob-0"})(["margin-bottom:0rem;"]);Label.displayName="Label";const TappableLabel=/*#__PURE__*/styled(Label).withConfig({componentId:"sc-10af9ob-1"})(["cursor:pointer;"]);TappableLabel.displayName="TappableLabel";

export { TappableLabel, Label as default };
